export default __webpack_public_path__ + "assets/1cd7d540a9e3c7a0ac2ba823ef1fb703.svg";